{
  "title": "Créer un compte",
  "subtitle": "Inscrivez-vous pour commencer",
  "emailLabel": "E-mail",
  "passwordLabel": "Mot de passe",
  "confirmPasswordLabel": "Confirmer mot de passe",
  "signUpButton": "S'inscrire",
  "requirementsText": "Doit contenir au moins 8 caractères avec majuscules, minuscules et chiffres",
  "strengthLabel": "Force : {{strength}}",
  "passwordStrength": {
    "tooShort": "Trop court",
    "weak": "Faible",
    "fair": "Moyen",
    "good": "Bon",
    "strong": "Fort"
  },
  "alreadyHaveAccount": "Vous avez déjà un compte ?",
  "logIn": "Connexion",
  "errors": {
    "invalidEmail": "Veuillez entrer une adresse e-mail valide",
    "tooShort": "Le mot de passe doit contenir au moins 8 caractères",
    "needsUppercase": "Le mot de passe doit contenir au moins une lettre majuscule",
    "needsLowercase": "Le mot de passe doit contenir au moins une lettre minuscule",
    "needsNumber": "Le mot de passe doit contenir au moins un chiffre",
    "noMatch": "Mots de passe différents",
    "createFailed": "Échec de la création du compte",
    "createFailedRetry": "Échec de la création du compte. Veuillez réessayer.",
    "genericError": "Une erreur s'est produite. Veuillez réessayer."
  }
}
